import { getUserName } from '@/modules/user/utils/userName';

interface AuthorName {
  author:
    | {
        firstName: string | null | undefined;
        lastName: string | null | undefined;
      }
    | null
    | undefined;
  authorContext: string | null | undefined;
}

export const getAuthorName = (params: AuthorName) => {
  const { author, authorContext } = params;

  return `${getUserName(author)} ${authorContext ? `(${authorContext})` : ''}`;
};
